import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {

  constructor() { }

  private isLoaded = false;
  private loadPromise!: Promise<void>;

  load(apiKey: string): Promise<void> {
    if (this.isLoaded) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise<void>((resolve, reject) => {
      const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
      if (existingScript) {
        this.isLoaded = true;
        resolve(); // Script is already loaded
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&amp;callback=initMap&amp;libraries=maps,marker&amp;v=beta`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.isLoaded = true;
        resolve();
      };

      script.onerror = () => reject(new Error('Failed to load the Google Maps API'));

      document.head.appendChild(script);
    });

    return this.loadPromise;
  }


}
